import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'

export const accountColumns = (changeIdActiveStatusHandler: (selected: any) => void) => {
  return [
    {field: 'id', headerName: '유저 ID', width: 150, align: 'center', headerAlign: 'center'},

    {
      field: 'name',
      headerName: '이름',
      width: 230,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'accountType',
      headerName: '권한',
      width: 120,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        return (
          <div>
            <span>{params.row.accountTypeName}</span>
          </div>
        )
      },
    },
    {
      field: 'officeId',
      headerName: '사업소 번호',
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'officeName',
      headerName: '사업소 이름',
      width: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'phoneNumber',
      headerName: '전화번호',
      width: 250,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'email',
      headerName: '이메일',
      width: 250,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'cooperName',
      headerName: '팀',
      width: 170,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: 'idActiveStatus',
      headerName: '계정상태',
      width: 250,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: any) => {
        const isActive = params.row.idActiveStatus

        return (
          <div>
            {isActive ? (
              <ToggleOnIcon
                color='success'
                sx={{
                  fontSize: '50px',
                  transition: 'transform 0.3s ease',
                  transform: 'scale(1.2)',
                  '&:hover': {
                    transform: 'scale(1.4)',
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  changeIdActiveStatusHandler(params.row)
                }}
              />
            ) : (
              <ToggleOffIcon
                color='error'
                sx={{
                  fontSize: '50px',
                  transition: 'transform 0.3s ease',
                  transform: 'scale(1)',
                  '&:hover': {
                    transform: 'scale(1.2)',
                  },
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  changeIdActiveStatusHandler(params.row)
                }}
              />
            )}
          </div>
        )
      },
    },
  ]
}
